export default "__VITE_ASSET__2YUqNc4n__"